import { BRAND } from '../lib/brand';
import { Icon } from './Icon';

/**
 * "Try asking…" affordance — example prompts (overlay content, from brand strings).
 *
 * R28 (3.2): re-skinned into SOFT-LIFT chips (Wave-1 `.soft-lift` — elev-lift at rest, sinks to
 * elev-inset on press) with a quiet brass quote glyph, so they read as tactile "you could say this"
 * cards rather than plain outlines. They remain DISPLAY-ONLY: the visitor speaks the line aloud; the
 * chips just seed ideas.
 *
 * R29 X5 — tap-to-ask (tapping a chip → `sendUserText`) was scoped for wiring on the EXISTING send
 * path gated on `connected`. It is DEFERRED as display-only because TryAsking mounts ONLY pre-connect
 * (VoiceDemo renders it under `status === 'idle'`), so at its one call-site there is no live session to
 * send into. Wiring a real tap here would require a connect-then-queue flow (startWarming → connect →
 * ready → sendUserText), which is server-adjacent orchestration, not a presentation change — out of
 * this wave's scope per the handoff ("anything server-side needed → SKIP and report"). Reported to
 * Andy in the R29 review log §Needs-Andy. When an in-call TryAsking surface exists, pass an `onAsk`
 * that calls `sendUserText`, gated on `connected`.
 */
export function TryAsking() {
  const examples = BRAND.try_asking ?? [];
  if (!examples.length) return null;
  return (
    <div className="flex flex-col items-center gap-3">
      <span className="text-xs uppercase tracking-[0.18em] text-subtle">Try asking</span>
      <div className="flex flex-wrap justify-center gap-2.5">
        {examples.map((ex) => (
          <span
            key={ex}
            className="soft-lift inline-flex items-center gap-1.5 rounded-full bg-surface px-3.5 py-2 text-sm text-ink"
          >
            <Icon name="message" size={13} className="shrink-0 text-brass" />
            {ex}
          </span>
        ))}
      </div>
    </div>
  );
}
